@use '../../styles/text.scss' as text;

.spinner {
  display: inline-block;
  width: var(--spinner-size);
  height: var(--spinner-size);
  border: var(--spinner-thickness) solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  color: text.$text-tertiary;
  animation: spinnerRotate 0.7s linear infinite;
}

@keyframes spinnerRotate {
  to {
    transform: rotate(360deg);
  }
}

.dots {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: var(--spinner-size);
  height: var(--spinner-size);
  color: text.$text-tertiary;
}

.dot {
  width: 20%;
  height: 20%;
  background-color: currentColor;
  border-radius: 50%;
  animation: spinnerDotBounce 1.4s ease-in-out infinite both;

  &:nth-child(1) {
    animation-delay: -0.32s;
  }

  &:nth-child(2) {
    animation-delay: -0.16s;
  }
}

.radial {
  display: inline-flex;
  color: text.$text-tertiary;
  animation: spinnerRotate 1.5s linear infinite;
}

@keyframes spinnerDotBounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.5;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 1.4s;
  }

  .dot {
    animation: none;
    opacity: 1;
  }

  .radial {
    animation-duration: 3s;
  }
}
